<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JGu6mC/tc-custom/9781468316025.jpg?1699984721350" alt="This image is the cover for the book One Kiss or Two?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One Kiss or Two?
      </h1>
      <p class="bookDescription body article font2">
        <p>Humans have been greeting each other for thousands of years. It should be the most straightforward thing in the world, but this seemingly simple act is fraught with complications, leading to awkward misunderstandings, intercultural fumblings, and social gaffes that can potentially fracture relationships forever.Why is that? Why are greetings so important? Is there a right and wrong way to say hello? In his illuminating book One Kiss or Two?, Andy Scott—a well-traveled former diplomat and no stranger to botched first contacts himself—takes a closer look at what greetings are all about. In discovering how they have developed over human history, he uncovers a kaleidoscopic world of etiquette, body-language, evolution, neuroscience, anthropology, and history. Through in-depth research and his personal experiences, and with the help of experts ranging from the world-famous primatologist Jane Goodall to the leading sociologist of the twentieth century Erving Goffman, Scott takes readers on a captivating journey through a subject far richer than we might have expected. By the end of it, we are able to make more sense of what lies behind greetings—and what it means to be human in the modern, cross-cultural age.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andy Scott
      </h2>
      
      <p class="authorDescription body article">Andy Scott has greeted people in more than sixty countries. He earned his PhD in history from Cambridge University. He has since served as a diplomat in Libya and Sudan and been a consultant to the UN Office for the Coordination of Humanitarian Affairs, and is now a Conflict and Stabilisation Adviser in the UK Government.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70573640